var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"loader"},[_c('div',{staticClass:"sbl-circ-path",style:({width: _vm.s + 'px', height: _vm.s + 'px', 'border-width': _vm.w + 'px'})})])
}
var staticRenderFns = []

export { render, staticRenderFns }